import React, { Component } from 'react'
import { Div, Input, DatePicker, CheckerBox, InputDecimal, DropDownList } from "../../core"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from "@material-ui/core/TablePagination"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import $ from 'jquery'
import moment from 'moment'
import utilityHelper from '../../../helpers/helperUtil'
import tableHelper from '../../../helpers/tableHelper'
import head_item from '../datas/head_item.json'
import { msg } from '../../Notifications/MsgBox'
import {Storage} from "../../../configs"
import {
    EVENT_CURRENT_GRITEM_SELECTED,
    EVENT_GET_PO_GRITEM_ORIGINAL,
    EVENT_GET_PO_RELEASE_ORDER
} from '../../../configs/EventTypes'
const numeral = require('numeral')


class GRItemList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            purchase_checkall: false,
            order_item: "asc",
            orderBy_item: "",
            selected_item: [],
            page_item: 0,
            rowsPerPage_item: 25,
            head_item: head_item
        }

        this.setItemModal = this.setItemModal.bind(this)
        this.handleGRItemClick = this.handleGRItemClick.bind(this)
        this.handleSelectAllGRItemClick = this.handleSelectAllGRItemClick.bind(this)
        this.setHeaderCheckAll=this.setHeaderCheckAll.bind(this)
        this.setReleaseOrderModal = this.setReleaseOrderModal.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        
    }

    componentWillReceiveProps(nextProps) {
        let {
            t_GR_ITEM
        } = this.props

        if (t_GR_ITEM != nextProps.t_GR_ITEM) {
            let Ischeckedrow = this.setHeaderCheckAll(nextProps.t_GR_ITEM)
            this.setState({
                local_t_GR_ITEM: [...nextProps.t_GR_ITEM],
                purchase_checkall : Ischeckedrow
            })
        }
    }

    setItemModal(type, index = "") {
        const {
            is_contract,
            t_GR_ITEM,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            t_GR_SERVICE
        } = this.props

        const {
            local_t_GR_ITEM
        } = this.state

        let viewmode = false

        let item = local_t_GR_ITEM[index]
        if (item) {
            if (is_contract) {
                viewmode = item.sap_final ? true : false
            }
            else {
                viewmode = (item.remaining_qty == 0 || item.sap_final) ? true : false
            }
        }
        
        let getSecondsOnclick = ''
        var date = new Date();
        getSecondsOnclick = date.getSeconds();

        let data = {
            index: index,
            viewmode: viewmode,
            type: type,
            headerModal: "รายละเอียดการรับสินค้า",
            onclickdate : getSecondsOnclick
        }

        window.emitter.emit(EVENT_CURRENT_GRITEM_SELECTED, {
            itemDetail: item,
            setDataItemModal: data,
            item_gr: t_GR_ITEM,
            item_account_assignment_gr: t_GR_ITEM_ACCOUNT_ASSIGNMENT,
            is_contract: is_contract
        })

    }

     handleSelectAllGRItemClick(event, object, listName, selectedName) {
        let { is_contract } = this.props

        let {
            local_t_GR_ITEM
        } = this.state

        const checked = event.target && event.target.checked ? 1 : 0

        if (checked == 1) {

            let objItem = local_t_GR_ITEM.find(s => s.checked == '1' || s.checked == 1 || s.checked == true )

            if (is_contract) {
                local_t_GR_ITEM.map((item, index) => {
                    if (!item.sap_final) {

                        local_t_GR_ITEM[index].checked = checked
                        if (typeof (objItem) !== "undefined") {
                            local_t_GR_ITEM[index].goods_recipient = objItem.goods_recipient
                            local_t_GR_ITEM[index].requisitioner = objItem.requisitioner
                            local_t_GR_ITEM[index].unloading_point = objItem.unloading_point
                        }

                    }
                })
            }
            else {
                local_t_GR_ITEM.map((item, index) => {
                    if (Number(item.remaining_qty) !== 0 && !item.sap_final) {

                        local_t_GR_ITEM[index].checked = checked
                        if (typeof (objItem) !== "undefined") {
                            local_t_GR_ITEM[index].goods_recipient = objItem.goods_recipient
                            local_t_GR_ITEM[index].requisitioner = objItem.requisitioner
                            local_t_GR_ITEM[index].unloading_point = objItem.unloading_point
                        }
                    }
                })
            }

        }
        else {

            if (is_contract) {
                local_t_GR_ITEM.map((item, index) => {
                    if (!item.sap_final) {
                        local_t_GR_ITEM[index].checked = checked
                    }
                })
            }
            else {
                local_t_GR_ITEM.map((item, index) => {
                    if (Number(item.remaining_qty) !== 0 && !item.sap_final) {
                        local_t_GR_ITEM[index].checked = checked
                   }
                })
            }

        }

        let Ischeckedrow = this.setHeaderCheckAll(local_t_GR_ITEM)
        this.setState({
            local_t_GR_ITEM: local_t_GR_ITEM, purchase_checkall : Ischeckedrow
        })

    }

    handleGRItemClick(event, index, listName, selectedName, choose_item = "") {
        if (!event) return
        
        let {
            local_t_GR_ITEM
        } = this.state
        
        if (event && event.target.checked) {

            if (listName === "t_GR_ITEM") {
                let objItem = local_t_GR_ITEM.find(s => s.checked == '1' || s.checked == 1 || s.checked == true )
                if (typeof (objItem) !== "undefined") {

                    local_t_GR_ITEM[index].goods_recipient = objItem.goods_recipient
                    local_t_GR_ITEM[index].requisitioner = objItem.requisitioner
                    local_t_GR_ITEM[index].unloading_point = objItem.unloading_point

                }
            }

            local_t_GR_ITEM[index].checked = 1
        }
        else {
            local_t_GR_ITEM[index].checked = 0
        }

        let Ischeckedrow = this.setHeaderCheckAll(local_t_GR_ITEM)
        this.setState({
            local_t_GR_ITEM: local_t_GR_ITEM, purchase_checkall: Ischeckedrow
        })
        //this.props.updateGR_Detail(value, name)
        //this.props.updateGR_Item(local_t_GR_ITEM, "", "",true)
    }
    
    setHeaderCheckAll(object){
        let Ischeckedrow = false
        let getcheckrow = object.filter((data) => {
            return data && data.checked == 1
        })
        if (getcheckrow && getcheckrow.length == object.length) {
            Ischeckedrow = true
        }
        return Ischeckedrow
    }


    handleChangeItem(event, index) {
        let {
            local_t_GR_ITEM
        } = this.state

        const target = event.target;
        const valid = event.target.validity.valid
        let value =  target.value;
        const name = target.name;

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }

        if (name === "receive_qty") {
            let current = local_t_GR_ITEM[index]
            if (current[name] != value) {
                const { po_no
                } = this.props

                let is_contract = utilityHelper.checkIsContract(po_no);

                let objitem = local_t_GR_ITEM[index]
                if (objitem) {
                    if (is_contract) {
                        if (objitem.po_qty) {
                            let _po_qty = utilityHelper.parseFloat(objitem.po_qty)
                            let _receive_qty = utilityHelper.parseFloat(value)
                            if (_receive_qty > _po_qty) {
                                msg.error('Receive Qty มากกว่า PO/Target Qty กรุณาตรวจสอบข้อมูล')
                            }
                            
                        }
                    }
                    else {
                        if (objitem.remaining_qty) {
                            let _remaining_qty = utilityHelper.parseFloat(objitem.remaining_qty)
                            let _receive_qty = utilityHelper.parseFloat(value)
                            if (_receive_qty > _remaining_qty) {
                                msg.error('Receive Qty มากกว่า Remaining Qty กรุณาตรวจสอบข้อมูล')
                            }
                            else if (_receive_qty < _remaining_qty) {
                                msg.warning('Receive Qty น้อยกว่ายอด Remaining Qty')
                            }
                        }
                    }
                }
            }
        }

        if (valid) {

            let current = local_t_GR_ITEM[index]
            if (current[name] != value) {
                local_t_GR_ITEM[index][name] = value
                this.setState({local_t_GR_ITEM: local_t_GR_ITEM})
            }

            if(name === "goods_recipient" || name === 'unloading_point' || name === 'requisitioner'){
                for(let i=0;i<local_t_GR_ITEM.length;i++){
                    if(
                        index !== i &&
                        (local_t_GR_ITEM[i][name]==null || local_t_GR_ITEM[i][name]=="") &&
                        (local_t_GR_ITEM[i].checked === 1 ||  local_t_GR_ITEM[i].checked === "1")
                    )
                    local_t_GR_ITEM[i][name] = value
                }
                this.setState({local_t_GR_ITEM: local_t_GR_ITEM})
            }

        } else {
            return
        }
    }

    getStorageLocation_ByPlant(plantcode) {
        let result = null
        const { storage_locations } = this.props

        result = storage_locations && storage_locations.filter(f => f.plant === plantcode)
        if (result) {
            result = utilityHelper.toSelectList(result, "sloC_NAME", "sloc")
        }
        return result
    }

    AddItemModal(type) {
        const { po_no
        } = this.props

        let unitCode = null
        let employeePIS = Storage.getEmployeePIS()
        let user = Storage.getUser()

        if (!employeePIS) {
            unitCode = user.unitCode
        }
        else {
            unitCode = employeePIS.departmentCode
        }
        
        // console.group("AddItemModal()")
        // console.log("po_no:")
        // console.log(po_no)
        // console.log("user:")
        // console.log(user.userName)
        // console.groupEnd()

        //this.props.getPODetailOriginal(po_no, unitCode);
        window.emitter.emit(EVENT_GET_PO_GRITEM_ORIGINAL, {
            po_no: po_no,
            unitCode: unitCode,
            userId: user.userName
        })

        if (type == "item") {
            window.$('#AddItemModal').modal('show');
        }
    }

    setReleaseOrderModal(type, itemNo = "", contractItemNo = "", po_qty = "", order_unit ="") {
       
        const { po_no
        } = this.props
        
        if (contractItemNo != "" && contractItemNo != null){
            itemNo = contractItemNo
        }

        window.emitter.emit(EVENT_GET_PO_RELEASE_ORDER, {
            po_no: po_no,
            itemNo: itemNo,
            target_qty: po_qty,
            unit: order_unit,
            type: "item"
        })

        window.$('#ReleaseOrderModal').modal('show');
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    render() {
        const {
            viewMode,
            po_no,
            is_contract,
            docTypeItem
        } = this.props

        const {
            local_t_GR_ITEM,
            purchase_checkall,
            head_item,
            order_item,
            orderBy_item,
            page_item,
            rowsPerPage_item
        } = this.state

        return (
            <React.Fragment>
                {local_t_GR_ITEM && local_t_GR_ITEM.length > 0 && (
                    <div className="rrs-detail pt-1 pb-0 px-5">
                        <div className="sp-table-container">
                            <div className="row rrs-table-hdr-wrap">
                                <div className="col"><h2 className="rrs-table-hdr">รายการรับสินค้า</h2></div>
                            </div>
                            <div className="row sp-pagination-control-top">
                                <Div className="col-auto create-button" doctype={docTypeItem} tagid="gr.purchase_header.add" viewMode={viewMode}>
                                    <a href="#" className="sp-bt-addmore" onClick={() => this.AddItemModal("item")} data-toggle="modal">
                                        <i className="icon btn-plus" />
                                        <span>เพิ่ม</span>
                                    </a>
                                </Div>
                            </div>
                            <div className="row no-gutters sp-table-content">
                                <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                    <TableHead>
                                        <TableRow className="sp-table-header">
                                            <TableCell padding="checkbox" className="th-table text-center">
                                                <CheckerBox
                                                    key={`header-goods-checkall`}
                                                    checked={purchase_checkall}
                                                    onChange={(event) => this.handleSelectAllGRItemClick(event, local_t_GR_ITEM, "t_GR_ITEM", "selected_item")}
                                                    inputProps={{ "aria-label": "select all item" }}
                                                    color="primary"
                                                    viewMode={viewMode}
                                                />
                                            </TableCell>
                                            {is_contract == true && (
                                                <TableCell className="th-table text-center danger-color" style={{ display: viewMode ? "none" : "" }}>
                                                    Delete
                                                </TableCell>
                                            )}
                                            {head_item && head_item.map(row => (

                                                (row.id === "po" && row.iscontract == is_contract) ? null : <TableCell
                                                    className="th-table text-center"
                                                    key={row.id}
                                                    padding={row.disablePadding ? "none" : "default"}
                                                    sortDirection={orderBy_item === row.id ? order_item : false}
                                                    style={{ minWidth: row.width, display: (is_contract == true && row.id == "remaining_qty") ? "none" : "" }}

                                                >
                                                    {!row.disableSort && (<TableSortLabel
                                                        active={orderBy_item === row.id}
                                                        direction={order_item}
                                                        onClick={() => this.handleRequestSort("order_item", "orderBy_item", row.id)}
                                                    >
                                                        <div className="th-text">{row.label}</div>
                                                        {orderBy_item === row.id ? (
                                                            <span
                                                                style={{
                                                                    border: 0,
                                                                    clip: "rect(0 0 0 0)",
                                                                    height: 1,
                                                                    margin: -1,
                                                                    overflow: "hidden",
                                                                    padding: 0,
                                                                    position: "absolute",
                                                                    top: 20,
                                                                    width: 1
                                                                }}
                                                            >
                                                                {order_item === "desc"
                                                                    ? "sorted descending"
                                                                    : "sorted ascending"}
                                                            </span>
                                                        ) : null}
                                                    </TableSortLabel>)}
                                                    {row.disableSort && (
                                                        <div className="th-text">{row.label}</div>
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableHelper.stableSort(local_t_GR_ITEM, tableHelper.getSorting(order_item, orderBy_item))
                                            .slice(page_item * rowsPerPage_item, page_item * rowsPerPage_item + rowsPerPage_item)
                                            .map((row, index) => {
                                                const isItemSelected = (row.checked == 1 ? true : false);
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                let index_start = (page_item * rowsPerPage_item);

                                                let docType = utilityHelper.getDocType(po_no, row.a, row.i, row.material, null)
                                                // let IsEdit = is_contract ? (row.sap_final == "1" ? true : false) : (Number(row.remaining_qty) === 0 || row.sap_final == "1" ? true : false)
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={`row-goods-item-${index}`}
                                                        selected={isItemSelected}
                                                    >
                                                        {is_contract == true && (
                                                            <TableCell padding="checkbox">
                                                                <CheckerBox
                                                                    key={`row-goods-item-check-${index}-${row.checked}`}
                                                                    checked={isItemSelected}
                                                                    inputProps={{ "aria-labelledby": labelId }}
                                                                    color="primary"
                                                                    onChange={(event) => this.handleGRItemClick(event, Number(index_start + index), "t_GR_ITEM", "selected_item")}
                                                                    viewMode={viewMode || row.sap_final == "1"}
                                                                />
                                                            </TableCell>
                                                        )}
                                                        {is_contract == false && (
                                                            <TableCell padding="checkbox">
                                                                <CheckerBox
                                                                    key={`row-goods-item-check-${index}-${row.checked}`}
                                                                    checked={isItemSelected}
                                                                    inputProps={{ "aria-labelledby": labelId }}
                                                                    color="primary"
                                                                    onChange={(event) => this.handleGRItemClick(event, Number(index_start + index), "t_GR_ITEM", "selected_item")}
                                                                    viewMode={viewMode || Number(row.remaining_qty) === 0 || row.sap_final == "1"}
                                                                />
                                                            </TableCell>
                                                        )}


                                                        {is_contract == true && (
                                                            <TableCell className="action-icon" style={{ display: viewMode ? "none" : "" }}>
                                                                <button
                                                                    className="btn"
                                                                    onClick={() => { this.props.onHandleDeleteGRItem("t_GR_ITEM", row) }}
                                                                    disabled={(row.contract_item_no != null ? false : true)}
                                                                >
                                                                    <i className="icon btn-trash" />
                                                                </button>
                                                            </TableCell>
                                                        )}
                                                        <TableCell className="action-icon">
                                                            <a href="#" onClick={() => this.setItemModal("item", Number(index_start + index))} data-toggle="modal" data-target="#itemModal">
                                                                <i className="icon bt-edit" />
                                                            </a>
                                                        </TableCell> 
                                                        {is_contract == true && (
                                                            <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setReleaseOrderModal("item", row.item_no, row.contract_item_no, row.po_qty, row.order_unit)} data-toggle="modal" >
                                                                    <i className="icon btn-search-blue" /> 
                                                                </a>
                                                            </TableCell>
                                                        )}
                                                        <TableCell><label className="label-full text-grid">{row.item_no}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid ">{row.a}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid ">{row.i}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid ">{row.material}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <Input
                                                                    key={`service_${index_start}_${row.item_no}_${row.short_text}`}
                                                                    tagid="gr.item.short_text"
                                                                    doctype={docType}
                                                                    name={"short_text"}
                                                                    defaultValue={row.short_text}
                                                                    id="short_text"
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    viewMode={viewMode}
                                                                    maxlength="40"
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.short_text}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-right"><label className="label-full text-grid text-right">{numeral(row.po_qty).format('0,0.000')}</label></TableCell>
                                                        {is_contract !== true && (
                                                            <TableCell className="text-right"><label className="label-full text-grid text-right">{numeral(row.remaining_qty).format('0,0.000')}</label></TableCell>
                                                        )}
                                                        <TableCell className="text-right">
                                                            {Number(row.checked) == 1 && (
                                                                <InputDecimal
                                                                    key={`grItem_${index}_${row.item_no}_${row.receive_qty}`}
                                                                    tagid="gr.item.receive_qty"
                                                                    doctype={docType}
                                                                    type="text"
                                                                    name="receive_qty"
                                                                    pattern="[0-9.,]*"
                                                                    defaultValue={row.receive_qty ? (numeral(row.receive_qty).format('0,0.000')) : ""}
                                                                    className="form-control text-right"
                                                                    id="receive_qty"
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    step="0,0.000"
                                                                    floatingPoint={3}
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (<label className="label-full text-grid text-right">{numeral(row.receive_qty).format('0,0.000')}</label>)}
                                                        </TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.order_unit}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <React.Fragment>
                                                                    <DatePicker
                                                                        value={row.delivery_date
                                                                            ? moment(row.delivery_date).format('DD/MM/YYYY')
                                                                            : ""}
                                                                        name="delivery_date"
                                                                        id="delivery_date"
                                                                        onChange={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                        onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                        doctype={docType}
                                                                        tagid="gr.item.delivery_date"
                                                                        viewMode={viewMode}
                                                                        readOnly={true}
                                                                    />
                                                                    
                                                                </React.Fragment>
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.delivery_date ? moment(row.delivery_date).format('DD/MM/YYYY') : ""}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-right">
                                                            {(Number(row.checked) == 1) && (
                                                                <InputDecimal
                                                                    key={`grItem_${index}_${row.item_no}_${row.net_price}`}
                                                                    type="text"
                                                                    id="net_price"
                                                                    name="net_price"
                                                                    pattern="[0-9.,]*"
                                                                    defaultValue={row.net_price ? (numeral(row.net_price).format('0,0.00')) : ""}
                                                                    className="form-control text-right "
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    floatingPoint={2}
                                                                    step="0,0.00"
                                                                    doctype={docType}
                                                                    tagid="gr.item.net_price"
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{numeral(row.net_price).format('0,0.00')}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.currency}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.per}</label></TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.opu}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1) && (
                                                                <InputDecimal
                                                                    key={`service_${index_start}_${row.item_no}_${row.requisitioner}`}
                                                                    doctype={docType}
                                                                    tagid="gr.item.requisitioner"
                                                                    type="text"
                                                                    name="requisitioner"
                                                                    pattern="[0-9]*"
                                                                    defaultValue={row.requisitioner || ''}
                                                                    className="form-control"
                                                                    id="requisitioner"
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    maxlength="8"
                                                                    floatingPoint={0}
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (
                                                                <label className="label-full text-grid">{row.requisitioner}</label>
                                                            )}
                                                        </TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.plant}</label></TableCell>
                                                        <TableCell>
                                                            {(Number(row.checked) == 1 && row.material !== undefined && !row.a) && (
                                                                <DropDownList
                                                                    key={`grItem_${index}_${row.item_no}_${row.storage_location}`}
                                                                    tagid="gr.item.storage_location"
                                                                    doctype={docType}
                                                                    name="storage_location"
                                                                    options={this.getStorageLocation_ByPlant(row.plant)}
                                                                    selected={row.storage_location}
                                                                    onSelectChanged={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    viewMode={viewMode}
                                                                >
                                                                </DropDownList>
                                                            )}
                                                            {((Number(row.checked) !== 1) || (row.checked === 1 && row.material === undefined))
                                                                && (<label className="label-full text-grid">{row.storage_location}</label>)}
                                                        </TableCell>
                                                        <TableCell className="text-center"><label className="label-full text-grid">{row.storage_bin}</label></TableCell>
                                                        <TableCell>
                                                            {Number(row.checked) == 1 && (
                                                                <InputDecimal
                                                                    key={`grItem_${index}_${row.item_no}_${row.goods_recipient}`}
                                                                    tagid="gr.item.goods_recipient"
                                                                    doctype={docType}
                                                                    type="text"
                                                                    name="goods_recipient"
                                                                    pattern="[0-9]*"
                                                                    defaultValue={row.goods_recipient || ''}
                                                                    className="form-control"
                                                                    id="goods_recipient"
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    inputMode="decimal"
                                                                    floatingPoint={0}
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (<label className="label-full text-grid">{row.goods_recipient}</label>)}
                                                        </TableCell>
                                                        <TableCell>
                                                            {Number(row.checked) == 1 && (
                                                                <Input
                                                                    key={`grItem_${index}_${row.item_no}_${row.unloading_point}`}
                                                                    doctype={docType}
                                                                    tagid="gr.item.unloading_point"
                                                                    name={"unloading_point"}
                                                                    defaultValue={row.unloading_point || ''}
                                                                    id="unloading_point"
                                                                    onBlur={(event) => this.handleChangeItem(event, Number(index_start + index))}
                                                                    maxlength="25"
                                                                    viewMode={viewMode}
                                                                />
                                                            )}
                                                            {(Number(row.checked) !== 1) && (<label className="label-full text-grid">{row.unloading_point}</label>)}
                                                        </TableCell>
                                                        {/* <TableCell className="action-icon">
                                                                <CheckerBox
                                                                    key={`grItem_${index}_${row.item_no}`}
                                                                    doctype={docType}
                                                                    tagid="gr.item.final"
                                                                    name={"final"}
                                                                    id={"final" + index}
                                                                    onChange={(event) => this.handleChangeItem(event,  Number(index_start + index))}
                                                                    checked={row.final == 1}
                                                                    value={row.final || false}
                                                                    color="primary"
                                                                    viewMode={viewMode || row.checked != 1 || row.sap_final == 1}
                                                                />
                                                            </TableCell> */}
                                                    </TableRow>
                                                );

                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>)}
                {local_t_GR_ITEM && local_t_GR_ITEM.length > 0 && (
                    <div className="rrs-detail pt-0 pb-1 px-5">
                        <TablePagination
                            className="pager"
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={local_t_GR_ITEM.length}
                            rowsPerPage={rowsPerPage_item}
                            page={page_item}
                            backIconButtonProps={{
                                "aria-label": "previous page"
                            }}
                            nextIconButtonProps={{
                                "aria-label": "next page"
                            }}
                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page_item")}
                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page_item", "rowsPerPage_item")}
                        />
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default GRItemList